module.exports = __webpack_public_path__ + "img/logo-white.64a7843c.png";